<script lang="ts" setup>
import { TruckStatus } from "@/constants/truck";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const facilities = [
  {
    key: "rental",
    label: "maps.rental-points",
    icon: "mdi-key",
    bgClass: "bg-purple-darken-2",
    textClass: "text-purple-darken-2",
  },
  {
    key: "cross",
    label: "maps.cross-points",
    icon: "mdi-forklift",
    bgClass: "bg-cyan-darken-2",
    textClass: "text-cyan-darken-2",
  },
];

const truckStatuses = [
  {
    status: TruckStatus.Available,
    label: "trucks.status-a",
    badgeClass: "bg-green-lighten-5 border-green",
    textClass: "text-green",
  },
  {
    status: TruckStatus.WillBeAvailable,
    label: "trucks.status-w",
    badgeClass: "bg-indigo-lighten-5 border-indigo",
    textClass: "text-indigo",
  },
  {
    status: TruckStatus.InRoute,
    label: "trucks.status-r",
    badgeClass: "bg-amber-lighten-5 border-amber-darken-3",
    textClass: "text-amber-darken-3",
  },
  {
    status: TruckStatus.NotAvailable,
    label: "trucks.status-n",
    badgeClass: "bg-grey-lighten-4 border-grey-darken-1",
    textClass: "text-grey-darken-1",
  },
  {
    status: TruckStatus.OnHold,
    label: "trucks.status-h",
    badgeClass: "bg-red-lighten-5 border-red-lighten-1",
    textClass: "text-red-lighten-1",
  },
];
</script>

<template>
  <div class="legend-content">
    <div class="d-flex align-center justify-space-between mt-3">
      <span class="font-weight-500 text-grey-darken-3">{{ t("trucks.truck-status") }}</span>
    </div>

    <div v-for="item in truckStatuses" :key="item.status" class="d-flex align-center mt-3 legend-content__row">
      <div :class="[item.badgeClass, item.textClass]" class="legend-content__badge">
        <v-icon size="16">mdi-truck</v-icon>
      </div>
      <span :class="item.textClass" class="font-weight-500 ml-3">{{ t(item.label) }}</span>
    </div>

    <div class="font-weight-500 text-grey-darken-3 mb-3 mt-5">{{ t("company.facilities") }}</div>

    <div v-for="facility in facilities" :key="facility.key" class="d-flex align-center mt-3 legend-content__row">
      <div :class="facility.bgClass" class="legend-content__facility-icon">
        <v-icon color="white" size="16">{{ facility.icon }}</v-icon>
      </div>
      <span class="font-weight-500 ml-3 text-grey-darken-2">{{ t(facility.label) }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.legend-content {
  &__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 24px;
    border-width: 2px;
    border-style: solid;
    border-radius: 8px;
  }

  &__facility-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
  }
}
</style>
